import { z } from "zod";

export const updateCartonDesignConfigurationSchema = z.object({
	designId: z.string().nullish(),
	designIdAttribute: z.string().nullish(),
	xValueExpressions: z.record(z.string(), z.string()),
});
